// Slow editorial marquee. `items` = array of strings; separated by a diamond.
export default function Marquee({ items = [], className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`marquee-pause overflow-hidden whitespace-nowrap ${className}`}>
      <div className="inline-flex animate-marquee">
        {row.map((t, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="px-8">{t}</span>
            <span className="text-aqua">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
